import { Fragment, useContext, useEffect } from "react";
import { EbookQuickOrderLineEntry } from "../ebookQuickOrderLineEntry";
import { GlobalContext } from "../../../Context/GlobalContext";
import { QuickOrderMyCard } from "../../QuickOrder/quickOrdSidePopup/QuickOrderMyCard";
import { MyCartSideSkeleton } from "../../../Skeleton/myCartSideSkeleton";
import { QuickOrderOrderDetails } from "../../QuickOrder/quickOrdSidePopup/QuickOrderOrderDetails";
import { EmptyCart } from "../../../Layout/Common/emptyCart";
import { isValidArray } from "../../../Layout/Common/common";
import { SearchProductItem } from "./searchProductItem";
import { CartItemBody } from "../../../Layout/MainLayout/cartSidePopup/carditemBody";

export const ProductEntryContainer = () => {
  const { CartItem, setCartItem } = useContext(GlobalContext);

  useEffect(() => {
  }, [CartItem]);

  return (
    <div className="tab-pane fade active show" id="pills-productLine" role="tabpanel" aria-labelledby="pills-home-tab">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <SearchProductItem />
          </div>
          <div className="col-lg-12">
            <div className="added-cartPopup quickOrder-panel p-0">
              {CartItem && isValidArray(CartItem.cartItem) ? (
                <Fragment>
                  <h3 className="quickOrder-title">
                    My Cart <span>({CartItem.totalItem} Items)</span>
                  </h3>
                  <CartItemBody cartItemList={CartItem.cartItem} totalItem={CartItem.totalItem} />
                </Fragment>
              ) : CartItem ? (
                <EmptyCart showHomeButton={false} showQuickOrderButton={true} />
              ) : (
                <MyCartSideSkeleton count={3} />
              )}
            </div>
          </div>
          <QuickOrderOrderDetails />
        </div>
      </div>
    </div>
  );
};
